import React from 'react';
import { useTranslation } from 'react-i18next';

import { UpdateIcon } from '@/shared/assets/icons/update-icon';
import { useAppVersionRefreshPrompt } from '@/shared/hooks/use-app-version-refresh-prompt/use-app-version-refresh-prompt';

import {
  AppVersionRefreshBadgeButton,
  AppVersionRefreshBadgeLabel,
} from './app-version-refresh-badge.styled';
import { getBalancedLabelLines } from './app-version-refresh-badge.utils';

export const AppVersionRefreshBadge = () => {
  const { t } = useTranslation();
  const { isUpdateAvailable, refreshApp } = useAppVersionRefreshPrompt();

  if (!isUpdateAvailable) {
    return null;
  }

  const title = t('common:new_version_available');
  const description = t('common:new_version_available_description');
  const badgeLabel = t('common:new_version_available_badge');

  return (
    <AppVersionRefreshBadgeButton
      aria-label={title}
      icon={<UpdateIcon />}
      onClick={refreshApp}
      size="large"
      tooltip={`${title}. ${description}`}
      variant="secondary"
    >
      <AppVersionRefreshBadgeLabel>
        {getBalancedLabelLines(badgeLabel).map((line, index) => (
          <span key={`${line}-${index}`}>{line}</span>
        ))}
      </AppVersionRefreshBadgeLabel>
    </AppVersionRefreshBadgeButton>
  );
};
